import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { isLoggedIn, hasAssetAccess } from '../../services/paywall';
import { useAccessContext } from '../AccessProvider/AccessProvider';

const usePaywallState = (asset: SvpAssetAdditional) => {
  const access = useAccessContext();

  return {
    paywallState: {
      isFetching: access.isFetching,
      isFetched: access.isFetched,
      isLoggedIn: isLoggedIn(access.accesses),
      hasAccess: hasAssetAccess(asset, access.accesses),
    },
  };
};

export { usePaywallState };
